import classNames from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './NavMenu.module.css';
export var NavMenuItem = function (props) {
    var _a, _b;
    var textClass = classNames(styles.text, (_a = {},
        _a[styles.navCollapses] = props.collapses,
        _a[styles.textDisabled] = props.disabled,
        _a));
    if (props.disabled) {
        var disabledLink = classNames(styles.link, (_b = {},
            _b[styles.linkDisabled] = props.disabled,
            _b));
        return (React.createElement("div", { className: disabledLink },
            React.cloneElement(props.icon, { className: styles.icon }),
            React.createElement("div", { className: textClass }, props.title)));
    }
    var testId = props.testId ? "navlink_" + props.testId : null;
    return (React.createElement(NavLink, { to: { pathname: props.location, state: { referrer: props.referrerLocation, modal: props.isNavModal } }, exact: props.exact, title: props.title, replace: props.replace, className: styles.link, onClick: props.onClick, activeClassName: styles.linkActive },
        React.cloneElement(props.icon, { className: styles.icon }),
        React.createElement("div", { className: textClass, "data-test-id": testId }, props.title)));
};
export var NavMenu = function (props) {
    var _a;
    var navMenuClass = classNames(styles.links, (_a = {},
        _a[styles.collapsed] = props.isCollapsed,
        _a));
    return (React.createElement("div", { className: navMenuClass }, React.Children.map(props.children, function (child) {
        if (child)
            return React.cloneElement(child, { collapses: props.collapses });
        return null;
    })));
};
